import React from 'react';
import MainBlockLayout from '../../components/MainBlockLayout';
import { Button, Row, Col, Card } from 'react-bootstrap';
import { t } from 'i18next';
//import { useState } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import { Trans } from 'react-i18next';
import MapWithMarkers from './components/MapWithMarkers';

import GuideDocument from '../../pages/Admissions/files/Registration guide.pdf';
import { Link } from 'react-router-dom';
import '../../../src/index.css'; 

function MainBlock() {
    //const [showGuideDoc, setShowGuideDoc] = useState(false);

    //const handleGuideDocClose = () => setShowGuideDoc(false);


    return (
        <>
        <div className='admissionsMainLayoutBlock'>
            <Row className="mb-4">
                <Col className="text-center">
                    <h2 className="fw-bold text-decoration-underline fs-2 how-register-text">
                        {t('admissions.how_register')}
                    </h2>
                    <p className="fs-4 how-register-text">
                        {t('admissions.step_guide')}
                    </p>
                </Col>
            </Row>
            
            <Row className="mb-5 gx-4">
                <Col md={6} className='mb-4 mb-3'>
                    <Card className="h-100 bg-opacity-25 p-3 admissions-step-card">
                        <Card.Body className="text-center">
                            <h4 className="fw-bold">
                                <span className="text-primary">♦</span><span className="text-white">{t('admissions.step_one')}</span>
                            </h4>
                            <p className="fs-6 text-white" >
                                {t('admissions.step_one_desc')}
                            </p>
                            <p className="fs-6">
                                <span className="bg-success text-white rounded px-1">✓</span> <span className="text-white">{t('admissions.step_one_note1')}</span>
                            </p>
                            <p className="fs-6">
                                <span className="bg-success text-white rounded px-1">✓</span> <span className="text-white">{t('admissions.step_one_note2')}</span>
                            </p>
                        </Card.Body>
                    </Card>
                </Col>
                
                <Col md={6} className='mb-4 mb-3'>
                    <Card className="h-100 bg-opacity-25 p-3 admissions-step-card">
                        <Card.Body className="text-center">
                            <h4 className="fw-bold">
                                <span className="text-primary">♦</span><span className="text-white"> {t('admissions.step_two')}</span>
                            </h4>
                            <p className="fs-6 text-white">
                                {t('admissions.step_two_desc')}
                            </p>
                            <p className="fs-6">
                                <span className="text-white">📄</span> <span className="text-white">{t('admissions.step_two_note')}</span>
                            </p>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            {/* step 3, addmissions fees */}
            <Row className="mb-5 gx-4 d-flex justify-content-center">
                <Col md={6} className='mb-4 mb-3'>
                    <Card className="h-100 bg-opacity-25 p-3 admissions-step-card">
                        <Card.Body className="text-center">
                            <h4 className="fw-bold">
                                <span className="text-primary">♦</span><span className="text-white"> {t('admissions.step_three')}</span>
                            </h4>
                            <p className="fs-6 text-white">
                                {t('admissions.step_three_desc')}
                            </p>
                            <p className="fs-6">
                                <span className="text-white">📄</span> <span className="text-white">{t('admissions.step_three_note')}</span>
                            </p>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            
            <Row className="mb-5">
                <Col className="d-flex align-items-center justify-content-center full_reg_column">
                    <p className="fw-bold text-dark text-center me-3 mb-0 admissions_guide_text">
                        <Trans i18nKey="admissions.guide_text" ></Trans>
                    </p>
                    <Button 
                        variant="primary"
                        href={GuideDocument}
                        download="Registration_Guide.pdf"
                        size="lg"
                    >
                        <Trans i18nKey="admissions.guide_button"/>
                    </Button>
                </Col>
            </Row>

            {/* Modal for PDF preview */}
            {/*<Modal show={showGuideDoc} onHide={handleGuideDocClose} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>{t('admissions.guide_modal_title')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <iframe
                        src={GuideDocument}
                        title="Registration Guide"
                        width="100%"
                        height="700px"
                        zoom="1.0"
                        style={{ border: 'none' }}
                    ></iframe>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleGuideDocClose}>
                        {t('admissions.close_button')}
                    </Button>
                </Modal.Footer>
            </Modal>*/}


            <Row className="mb-5 align-items-center justify-content-center">
                <MapWithMarkers />
            </Row>



            <Row className="mb-5 align-items-center justify-content-center ">
                <Button 
                    variant="primary" 
                    size="lg"
                    as={Link}
                    to={("/satellite-schools")}
                    className='w-50 h-100 admissions_locations_button'
                >
                    {t('admissions.all_locations_button')}
                </Button>
            </Row>

            <Row className="align-items-center mb-4">
                <h3 className="display-8 m-0 fw-bold text-center admissions-faq-title">
                    {t('admissions.faq')}
                </h3>
            </Row>


            <Accordion defaultActiveKey="0" className='custom-accordion mb-5'>
                {/* question 1*/}
                <Accordion.Item eventKey="0" className=' rounded px-1'>
                    <Accordion.Header><Trans i18nKey="admissions.question1" /></Accordion.Header>
                    <Accordion.Body className='text-start '>
                        <Trans i18nKey="admissions.answer1" />
                    </Accordion.Body>
                </Accordion.Item>

                {/* question 2*/}
                <Accordion.Item eventKey="1" className='border-none rounded px-1'>
                    <Accordion.Header><Trans i18nKey="admissions.question2" /></Accordion.Header>
                    <Accordion.Body className='text-start '>
                        <Trans i18nKey="admissions.answer2" />
                    </Accordion.Body>
                </Accordion.Item>

                {/* question 3*/}
                <Accordion.Item eventKey="2" className=' rounded px-1'>
                    <Accordion.Header><Trans i18nKey="admissions.question3" /></Accordion.Header>
                    <Accordion.Body className='text-start '>
                        <Trans i18nKey="admissions.answer3" />
                    </Accordion.Body>
                </Accordion.Item>

                {/* question 4*/}
                <Accordion.Item eventKey="3" className=' rounded px-1'>
                    <Accordion.Header><Trans i18nKey="admissions.question4" /></Accordion.Header>
                    <Accordion.Body className='text-start '>
                        <Trans i18nKey="admissions.answer4" />
                    </Accordion.Body>
                </Accordion.Item>

                {/* question 5*/}
                <Accordion.Item eventKey="4" className=' rounded px-1'>
                    <Accordion.Header><Trans i18nKey="admissions.question5" /></Accordion.Header>
                    <Accordion.Body className='text-start '>
                        <Trans i18nKey="admissions.answer5" />
                    </Accordion.Body>
                </Accordion.Item>

                {/* question 6*/}
                <Accordion.Item eventKey="5" className=' rounded px-1'>
                    <Accordion.Header><Trans i18nKey="admissions.question6" /></Accordion.Header>
                    <Accordion.Body className='text-start '>
                        <Trans i18nKey="admissions.answer6" />
                    </Accordion.Body>
                </Accordion.Item>

                {/* question 7*/}
                <Accordion.Item eventKey="6" className=' rounded px-1'>
                    <Accordion.Header><Trans i18nKey="admissions.question7" /></Accordion.Header>
                    <Accordion.Body className='text-start '>
                        <Trans i18nKey="admissions.answer7" />
                    </Accordion.Body>
                </Accordion.Item>

                {/* question 8*/}
                <Accordion.Item eventKey="7" className=' rounded px-1'>
                    <Accordion.Header><Trans i18nKey="admissions.question8" /></Accordion.Header>
                    <Accordion.Body className='text-start '>
                        <Trans i18nKey="admissions.answer8" />
                    </Accordion.Body>
                </Accordion.Item>

                {/* question 9*/}
                <Accordion.Item eventKey="8" className=' rounded px-1'>
                    <Accordion.Header><Trans i18nKey="admissions.question9" /></Accordion.Header>
                    <Accordion.Body className='text-start '>
                        <Trans i18nKey="admissions.answer9" />
                    </Accordion.Body>
                </Accordion.Item>

                {/* question 10*/}
                <Accordion.Item eventKey="9" className=' rounded px-1'>
                    <Accordion.Header><Trans i18nKey="admissions.question10" /></Accordion.Header>
                    <Accordion.Body className='text-start '>
                        <Trans i18nKey="admissions.answer10" />
                    </Accordion.Body>
                </Accordion.Item>

                
                {/* question 11*/}
                <Accordion.Item eventKey="10" className=' rounded px-1'>
                    <Accordion.Header><Trans i18nKey="admissions.question11" /></Accordion.Header>
                    <Accordion.Body className='text-start '>
                        <Trans i18nKey="admissions.answer11" />
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>


        </div>

        </>
    );
}

export default MainBlockLayout(MainBlock);